import { Depot } from "./Depot";
import { Product } from "./Product";

// Modelo base general de tarifas
export interface WarehouseQuoteRate {
    id?: number;

    container_entry_fee: number;       // Tarifa por ingreso del contenedor (valor fijo)
    daily_storage_fee: number;         // Tarifa por día de almacenaje (unitario x días)
    container_exit_fee: number;        // Tarifa por salida del contenedor (valor fijo)
    additional_comments?: string;      // Comentarios adicionales
    depot?: Depot[]
    depot_id?:number;
    
    product?: Product[]
    product_id?:number;

    container_entry_fee_currency?: string;   // Código o nombre de la moneda
    container_entry_fee_unit?: string;       // Nombre de la unidad

    daily_storage_fee_currency?: string;
    daily_storage_fee_unit?: string;

    container_exit_fee_currency?: string;
    container_exit_fee_unit?: string;
}


// Modelo usado en formularios, vistas y operaciones CRUD
export interface WarehouseQuoteRateDataForm {
    id?: number;
    quote_id?: number;

    container_entry_fee?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee?: number;        // Tarifa por día de almacenaje
    container_exit_fee?: number;       // Tarifa por salida del contenedor


    container_entry_fee_unit_id?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee_unit_id?: number;        // Tarifa por día de almacenaje
    container_exit_fee_unit_id?: number;       // Tarifa por salida del contenedor

    container_entry_fee_currency_id?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee_currency_id?: number;        // Tarifa por día de almacenaje
    container_exit_fee_currency_id?: number;       // Tarifa por salida del contenedor

    additional_comments?: string;      // Comentarios adicionales
    depot?: Depot[]
    depot_id?:number;

    product?: Product[]
    product_id?:number;
    created_at?: string;
    updated_at?: string;



    container_entry_fee_currency?: string;   // Código o nombre de la moneda
    container_entry_fee_unit?: string;       // Nombre de la unidad

    daily_storage_fee_currency?: string;
    daily_storage_fee_unit?: string;

    container_exit_fee_currency?: string;
    container_exit_fee_unit?: string;
}


export interface WarehouseQuoteShowRateDataForm {
    id?: number;
    quote_id?: number;

    container_entry_fee?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee?: number;        // Tarifa por día de almacenaje
    container_exit_fee?: number;       // Tarifa por salida del contenedor


    container_entry_fee_unit_id?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee_unit_id?: number;        // Tarifa por día de almacenaje
    container_exit_fee_unit_id?: number;       // Tarifa por salida del contenedor

    container_entry_fee_currency_id?: number;      // Tarifa por ingreso del contenedor
    daily_storage_fee_currency_id?: number;        // Tarifa por día de almacenaje
    container_exit_fee_currency_id?: number;       // Tarifa por salida del contenedor

    additional_comments?: string;      // Comentarios adicionales
    depot?: string
    depot_id?:number;

    product?: string

    product_id?:number;
    created_at?: string;
    updated_at?: string;



    container_entry_fee_currency?: string;   // Código o nombre de la moneda
    container_entry_fee_unit?: string;       // Nombre de la unidad

    daily_storage_fee_currency?: string;
    daily_storage_fee_unit?: string;

    container_exit_fee_currency?: string;
    container_exit_fee_unit?: string;
}
export const defaultWarehouseQuoteRateDataForm: WarehouseQuoteRateDataForm = {
  id: undefined,
  quote_id: undefined,

  container_entry_fee: 0,
  daily_storage_fee: 0,
  container_exit_fee: 0,

  container_entry_fee_unit_id: 0,
  daily_storage_fee_unit_id: 0,
  container_exit_fee_unit_id: 0,

  container_entry_fee_currency_id: 0,
  daily_storage_fee_currency_id: 0,
  container_exit_fee_currency_id: 0,

  additional_comments: '',

  depot: [],
  depot_id: undefined,

  product: [],
  product_id: undefined,

  created_at: undefined,
  updated_at: undefined,
};

export interface WarehouseQuoteRateFilters {
    page?: number;
    per_page?: number;
    sort?: string;
    order?: 'asc' | 'desc';
}
